import React, {  useMemo, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageTitle, TabSet, Alert } from '@gsa/afp-component-library';
import { useAppAbility } from '@gsa/afp-shared-ui-utils';
import Breadcrumbs from '../../widgets/breadcrumbs';
import MakeModelApprovalTable from './make-model-approval';
import MakeModelTable from './make-model';
import { OPERATIONS, SUBJECTS } from '../../utilities/constants';
import {
  makeModelStatusMessageAtom,
} from './atoms/make-model-atoms';


export default () => {
  const ability = useAppAbility();
  const canSeeApprovalTab = ability.can(OPERATIONS.View, SUBJECTS.makeModelApproval); // Engineers & site admin
  const title = 'Makes and models';
  const [toaster, setToaster] = useRecoilState(makeModelStatusMessageAtom);
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(
    () => [
      ...(canSeeApprovalTab
        ? [
            {
              heading: 'Make and model approval',
              tabKey: 'approval',
              content: <MakeModelApprovalTable />,
            },
          ]
        : []),
      {
        heading: 'Makes and models',
        tabKey: 'makes-and-models',
        content: <MakeModelTable />,
      },
    ],
    [canSeeApprovalTab],
  );

  // The open tab and its filters live in the URL (the filter panels write
  // their own filter-* params), so the browser back button restores both.
  const startingTabIndex = Math.max(
    tabs.findIndex(
      ({ tabKey }) => tabKey === new URLSearchParams(search).get('tab'),
    ),
    0,
  );

  // The tabs share some filter keys, so a tab switch starts from a URL with
  // only the new tab in it rather than handing it the other tab's filters.
  const handleTabSelect = (index) => {
    navigate(`${pathname}?tab=${tabs[index].tabKey}`, { replace: true });
  };

  useEffect(() => {
    setToaster(null); // clear toaster when page reload
  }, []);

  return (
    <>
      <Breadcrumbs
        current={title}
        path={[
          {
            location: `${window.AFP_CONFIG.appURLs?.home}/home`,
            label: 'Home',
          },
        ]}
      />
      {toaster && (
        <Alert
          slim
          focused
          type={toaster.type}
          onClose={() => setToaster(null)}
        >
          {toaster.message}
        </Alert>
      )}
      <PageTitle title={title} aria-label={title} />
      <p className="margin-bottom-6" data-testid="make-model-index-description">
        The makes and models page is an index of vehicle makes and models in
        GSAFleet.gov. This page serves as the interface for GSA Engineers to
        manage vehicle makes and models.
      </p>
      <TabSet
        tabs={tabs}
        startingTabIndex={startingTabIndex}
        onSelect={handleTabSelect}
      />
    </>
  );
};
